module.exports = __webpack_public_path__ + "static/media/profile.783591b1.jpg";